// removed by extract-text-webpack-plugin
module.exports = {"atheleteContainer":"Coach__atheleteContainer___Ui3qK","bannerAthelete":"Coach__bannerAthelete___bxTzR"};


//////////////////
// WEBPACK FOOTER
// ./src/containers/Coach/Coach.scss
// module id = 1572
// module chunks = 0